import { defineComponent, onMounted } from 'vue';
import Recommendations from './Recommendations.class';


export default defineComponent({
	setup: () => {
		const component = new Recommendations();
		onMounted(component.mounted.bind(component));

		return {
			dataIdentifier: component.dataIdentifier,
			selectedParentDiscipline: component.selectedParentDiscipline,
			countryFilterValues: component.countryFilterValues,
			portalType: component.portalType
		};
	},
});
